import React, { useEffect, useState } from "react";
import {
  AppBar, Container,
  Toolbar,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import {
  Apartment,
  ArrowRightAlt,
  CloudUpload,
  Contactless,
  CreditCard, Favorite,
  Flare, LiveTv,
  LocalGroceryStore,
} from "@material-ui/icons";

// styles
import useStyles from "./styles";

// pictures
import GLabLogo from "../../images/logo.svg";
import GLabOverview from "../../images/platform-llm.webp";

import { AIApps, DataInfra, DataApps, AppLogo } from "../../context/UserContext";


export default function Header() {
  const classes = useStyles();
  const thisYear = new Date().getFullYear()

  const [appMenu, setAppMenu] = useState(null);
  const [solutionMenu, setSolutionMenu] = useState(null);

  const handleClearAppMenu = () => {
    setAppMenu(null)
  };

  const handleClearSolutionMenu = () => {
    setSolutionMenu(null);
  }

  useEffect(() => {
    appMenu && window.addEventListener('click', handleClearAppMenu);
    return () => window.removeEventListener('click', handleClearAppMenu);
  });

  useEffect(() => {
    solutionMenu && window.addEventListener('click', handleClearSolutionMenu);
    return () => window.removeEventListener('click', handleClearSolutionMenu);
  })

  return (
    <AppBar id="attr" position="fixed" elevation={0} className={classes.appBar}>
      <Container maxWidth="lg">
        <Toolbar className={classes.toolbar}>
          <img
            src={GLabLogo}
            className={classes.logo}
            alt="glab-logo"
            onClick={() => window.open("#/app/home", "_self")}
          />

          <div className={classes.grow} />

          {/* Products */}
          <p
            className={classes.subTitle}
            onClick={event => setAppMenu(event.currentTarget)}
          >
            Products
            {!Boolean(appMenu) ? (
              <ExpandMoreIcon fontSize={"small"} />
            ) : (
              <ExpandLessIcon fontSize={"small"} />
            )}
          </p>
          <Card hidden={!Boolean(appMenu)} className={classes.headerMenu}>
            <Grid container>
              <Grid item xs={7}>
                <p className={classes.groupTitle}>AI Applications</p>
                {AIApps.map(it => (
                  <Grid container alignItems={"center"} key={it.category}>
                    <Grid item xs={3}>
                      <p className={classes.productTitle}>{it.category}</p>
                    </Grid>
                    {it.apps.map(app => (
                      <Grid item xs={3} key={app.name}>
                        <p
                          className={classes.toolName}
                          onClick={() => window.open(app.href, "_target")}
                        >
                          <img
                            src={
                              AppLogo[app.name.toLowerCase().replace(" ", "")]
                            }
                            alt="app-logo"
                          />
                          &nbsp;&nbsp;{app.name}
                        </p>
                      </Grid>
                    ))}
                  </Grid>
                ))}
                <Divider
                  orientation={"horizontal"}
                  className={classes.dividerApps}
                />
                <p className={classes.groupTitle}>Data Applications</p>
                {DataApps.map(it => (
                  <Grid container alignItems={"center"} key={it.category}>
                    <Grid item xs={3}>
                      <p className={classes.productTitle}>{it.category}</p>
                    </Grid>
                    {it.apps.map(app => (
                      <Grid item xs={2} key={app.name}>
                        <p
                          className={classes.toolName}
                          onClick={() => window.open(app.href, "_target")}
                        >
                          <img
                            src={
                              AppLogo[app.name.toLowerCase().replace(" ", "")]
                            }
                            alt="app-logo"
                          />
                          &nbsp;&nbsp;{app.name}
                        </p>
                      </Grid>
                    ))}
                  </Grid>
                ))}
                <Divider
                  orientation={"horizontal"}
                  className={classes.dividerApps}
                />
                <p className={classes.groupTitle}>Data Infrastructure</p>
                {DataInfra.map(it => (
                  <Grid container alignItems={"center"} key={it.category}>
                    <Grid item xs={3}>
                      <p className={classes.productTitle}>{it.category}</p>
                    </Grid>
                    {it.apps.map(app => (
                      <Grid item xs={2} key={app.name}>
                        <p
                          className={classes.toolName}
                          onClick={() => window.open(app.href, "_target")}
                        >
                          <img
                            src={
                              AppLogo[app.name.toLowerCase().replace(" ", "")]
                            }
                            alt="app-logo"
                          />
                          &nbsp;&nbsp;{app.name}
                        </p>
                      </Grid>
                    ))}
                  </Grid>
                ))}
              </Grid>
              <Grid item xs={5} className={classes.glabOverviewGrid}>
                <img
                  src={GLabOverview}
                  className={classes.glabOverviewImg}
                  alt="mgdc-platform-overview"
                />
              </Grid>
              <Grid item xs={12}>
                <Divider className={classes.divider} />
                <p className={classes.platformTag}>Venus 2024-{thisYear}</p>
              </Grid>
            </Grid>
          </Card>

          {/* Solutions */}
          <p
            className={classes.subTitle}
            onClick={event => setSolutionMenu(event.currentTarget)}
          >
            Solutions
            {!Boolean(solutionMenu) ? (
              <ExpandMoreIcon fontSize={"small"} />
            ) : (
              <ExpandLessIcon fontSize={"small"} />
            )}
          </p>
          <Card hidden={!Boolean(solutionMenu)} className={classes.headerMenu}>
            <Grid container>
              <Grid item xs={12}>
                <Grid container spacing={2} className={classes.solutionPart}>
                  <Grid item xs={4}>
                    <p className={classes.productTitle}>
                      <CreditCard color={"primary"} />
                      &nbsp;&nbsp;Financial Services
                    </p>
                    <span>
                      Your customers want fast, secure, digital banking on any
                      device. Deliver better experiences while meeting strict
                      regulations.
                    </span>
                  </Grid>
                  <Grid item xs={4}>
                    <p className={classes.productTitle}>
                      <CloudUpload color={"primary"} />
                      &nbsp;&nbsp;Manufacturing
                    </p>
                    <span>
                      From factory to cloud, automation accelerates production.
                      Modernize legacy systems to reduce operating expenses and
                      downtime.
                    </span>
                  </Grid>
                  <Grid item xs={4}>
                    <p className={classes.productTitle}>
                      <Favorite color={"primary"} />
                      &nbsp;&nbsp;Healthcare
                    </p>
                    <span>
                      Modern healthcare is more digital — and connected. Improve
                      patient outcomes with better collaboration across systems
                      and data.
                    </span>
                  </Grid>
                  <Grid item xs={4}>
                    <p className={classes.productTitle}>
                      <LiveTv color={"primary"} />
                      &nbsp;&nbsp;Media and Entertainment
                    </p>
                    <span>
                      Consumption habits are changing. Deliver high-quality
                      digital experiences across every screen, everywhere.
                    </span>
                  </Grid>
                  <Grid item xs={4}>
                    <p className={classes.productTitle}>
                      <Apartment color={"primary"} />
                      &nbsp;&nbsp;Public Sector
                    </p>
                    <span>
                      The era of digital government is here. Cloud helps
                      agencies modernize, stay secure, and deliver trusted
                      public services.
                    </span>
                  </Grid>
                  <Grid item xs={4}>
                    <p className={classes.productTitle}>
                      <LocalGroceryStore color={"primary"} />
                      &nbsp;&nbsp;Retail
                    </p>
                    <span>
                      Shoppers expect more. Meet them with fast, secure, and
                      consistent digital experiences — online and off.
                    </span>
                  </Grid>
                  <Grid item xs={4}>
                    <p className={classes.productTitle}>
                      <Flare color={"primary"} />
                      &nbsp;&nbsp;Technology
                    </p>
                    <span>
                      You’re building what’s next. Cloud automation helps you
                      move faster, secure your stack, and expand to new markets.
                    </span>
                  </Grid>
                  <Grid item xs={4}>
                    <p className={classes.productTitle}>
                      <Contactless color={"primary"} />
                      &nbsp;&nbsp;Telecom
                    </p>
                    <span>
                      Networks power everything. Stay ahead with infrastructure
                      that helps you deliver faster, safer, more reliable
                      service.
                    </span>
                  </Grid>
                  <Grid item xs={12}>
                    <p
                      onClick={() =>
                        window.open("https://cloud.labillion.cn", "_target")
                      }
                      className={classes.toolName}
                    >
                      VIEW ALL SOLUTIONS&nbsp;&nbsp;
                      <ArrowRightAlt />
                    </p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={1} />
              <Grid item xs={12}>
                <Divider className={classes.divider} />
                <p className={classes.platformTag}>Venus 2024-{thisYear}</p>
              </Grid>
            </Grid>
          </Card>

          {/* Customer */}
          <p
            className={classes.subTitle}
            onClick={() => window.open("#/app/customer", "_self")}
          >
            Customer
          </p>

          {/* Security */}
          <p
            className={classes.subTitle}
            onClick={() => window.open("#/app/security", "_self")}
          >
            Security
          </p>

          <div className={classes.grow} />

          {/* Resources */}
          <p
            className={classes.subTitle}
            onClick={() =>
              window.open("https://docs.data.labillion.cn/venus/", "_blank")
            }
          >
            Resources
          </p>

          <Button
            variant={"text"}
            className={classes.visitButton}
            onClick={() =>
              window.open("https://megaai.data.labillion.cn", "_blank")
            }
          >
            Login
          </Button>
          <div className={classes.gap} />
        </Toolbar>
      </Container>
    </AppBar>
  );
}
